<script>
  import {onMount, tick} from 'svelte'
  import page from 'page'

  import { parse, parseUrl } from 'query-string'

  import FormFieldTable,
         { isRowMatch } from './FormFieldTable.svelte'
  import FieldValueDetail from './FieldValueDetail.svelte'
  import FieldValueActions from './FieldValueActions.svelte'

  import { getApiUrl } from './util'

  import { fldvalsearchparams,
           fldvalsearchresult,
           fldvalselected,
           formfldvalselected,
           currentformid,
           pagectxstate } from './stores'

  import { showPage, getActiveElementNoBody, fetchWithSession } from './util'

  let mounted

  let subject
  let field
  let tablewrap

  let errorMessage

  let selectedRow = null

  $: { handlePageCtxStateChange($pagectxstate) }
  async function handlePageCtxStateChange(pgctxstate) {
    if (mounted) {
      const parsedurl = parseUrl(pgctxstate.path)
      console.log(parsedurl)
      if (parsedurl.query.subject !== subject ||
          parsedurl.query.field !== field ||
          $fldvalsearchparams.subject !== subject ||
          $fldvalsearchparams.field !== field) {
        doFieldSearch()
      }
    }
  }


  async function doFieldSearch() {
    const querystring = location.search

    const params = parse(querystring)
    console.dir(params)
    if (params.subject && params.field) {
      subject = params.subject
      field = params.field
    } else {
      subject = $fldvalsearchparams.subject
      field = $fldvalsearchparams.field
    }
    if (subject && field) {
      const apiurl = getApiUrl('fields', {subject, field})
      let res
      try {
        res = await fetchWithSession(apiurl, {cache: 'no-store'})
      } catch (err) {
        console.log(err)
      }
      if (res?.ok) {
        errorMessage = null
        const json = await res.json()
        console.dir(json)
        $fldvalsearchresult = json
        $fldvalsearchparams = {subject, field}
        selectRowFromStore()
      } else {
        $fldvalsearchresult = []
        $fldvalsearchparams = {subject, field}
        errorMessage = 'No result due to API error'
        console.log(res)
        res?.text().then(t => console.log(t))
      }
    } else {
      console.log('Field value search missing subject or field query parameters.')
    }
  }


  // Ensure storing reactive on only selectedRow.
  $: { storeSelectedRow(selectedRow) }
  function storeSelectedRow(r) {
    console.log('storeSelectedRow')
    if (r) {
      if ($fldvalselected !== r)
        $fldvalselected = r
      if ($pagectxstate.selectedRow !== r)
        $pagectxstate.selectedRow = r
      $currentformid = r.formid
    }
  }

  async function selectRowFromStore() {

    console.log('In selectRowFromStore')

    const selected = $pagectxstate.selectedRow ?? $fldvalselected

    let found = $fldvalsearchresult.find(
                      v => isRowMatch(v, selected))

    // If the stored selected is not found, select the first item.
    if (!found && $fldvalsearchresult.length > 0) {
      found = $fldvalsearchresult[0]
    }
    if (found) {
      console.log(`found.formid: ${found.formid}`)
      // This is the only time we set selectedRow outside of
      // FieldValueTable.
      selectedRow = found

      // Set focus on the corresponding TR if nothing else has focus.
      // TODO: Consider saving focus element (how?) and restoring if
      //       nothing else has the focus, regardless of whether in the
      //       table or not.
      await tick()
      tablewrap?.querySelector('.fieldvaluetable .selected')?.focus()
    }
  }

  onMount( () => {
    mounted = true
    console.log('onMount FieldValuePage')

    // values if set.
    // const qparams = parse(location.search)
    // subject = qparams.subject || $fldvalsearchparams.subject
    // field = qparams.field || $fldvalsearchparams.field

    doFieldSearch()

    // Set focus on the corresponding TR if nothing else has focus.
    //await tick()
    //if (!getActiveElementNoBody()) {
    //  tablewrap?.querySelector('.fieldvaluetable .selected')?.focus()
    //}
  })

  function handleSearchInputKeyDown(e) {
    if (e.key === "Enter") {
      search()
    }
  }

  //const search = () => dispatch('search')
  function search() {
    if (subject && field) {
      //getActiveElementNoBody()?.blur()
      showPage('/fldvals', {subject, field})
    } else {
      alert('Both subject and field must be specified for search')
    }
  }

  function handleRowClick(e) {
    console.log(e)
    let {row, selected} = e.detail
    console.log(selected)
    // Disabling this action for now because two-way binding
    // seems to be sufficient.
    //selectedRow = selected ? row : null
  }


  async function handleRowKeydown(e) {
    let { row, key, isRowSelected } = e.detail
    if (['f','F','p'].includes(key) && isRowSelected) {
      if (key === 'f') {
        // Set up for desired fldval row selection.
        $fldvalselected = { formid: row.formid,
                            formfieldid: row.formfieldid }
        await tick()
        showPage('/fldvals', { subject: row.subject,
                               field: row.fieldname })
      } else if (key === 'F') {
        $formfldvalselected = { formid: row.formid,
                                formfieldid: row.formfieldid }
        await tick()
        showPage('/form')
      } else if (key === 'p') {
        showPage('/subj', { subject: row.subject })
      }
    }
  }


  async function handleStaleFieldData(e) {
    console.log('onStaleFieldData')
    await doFieldSearch()
    // await tick()
    // e.detail?.onRefreshApiReturned?.()
  }

  // Might not need filtering for this table since the
  // number of rows should be small.
  // TODO: Looks like filterOptions can take an array of values
  //       that will be used for both name and value, which is
  //       pretty much what we want.
  const columns =
    [
      { key: 'subject',
        title: 'PID',
        value: v=>v.subject },
      { key: 'fieldname',
        title: 'Field',
        value: v=>v.fieldname,
        //filterOptions: rows => rows.map(r => ({name:r.fieldname,value:r.fieldname})),
        },
      { key: 'alias',
        title: 'Field alias',
        value: v=>v.alias },
      { key: 'shortformname',
        title: 'Form',
        value: v=>v.shortformname },
      { key: 'kstr',
        title: 'Value',
        value: v=>v.kstr,
        class: 'errorindicator' },
      { key: 'fstatus',
        title: 'Status',
        value: v=>v.fstatus,
        class: 'errorindicator' },
      //{ key: 'err_rows',
      //  title: 'Num err rows',
      //  value: v=>v.err_rows,
      //  //filterOptions: rows => rows.map(r => ({name:r.err_rows,value:r.err_rows})),
      //  },
      { key: 'errortype',
        title: 'Curr err type',
        value: v=>v.errortype || '',
        class: 'errorindicator' }
    ].map( col => ({ ...col, sortable: true }) )
    // The map call at the end makes all columns sortable.
</script>

<div class=searchparams on:keydown={handleSearchInputKeyDown}>
  <!-- fieldset on:keydown={handleSearchInputKeyDown} -->
    <label class=subjectlabel for=subjectinput>
      PID 
    </label>
    <input id=subjectinput maxlength=12 bind:value={subject} />
    <label for=fieldinput>
      Field 
    </label>
    <input id=fieldinput bind:value={field} />
    <button tabindex=-1 on:click={search}>Search</button>
  <!-- /fieldset -->
</div>

{#if $fldvalsearchresult.length}
  <div bind:this={tablewrap}>
  <FormFieldTable rows={ $fldvalsearchresult }
                  { columns }
                  bind:selectedRow
                  on:rowclick={handleRowClick}
                  on:rowkeydown={handleRowKeydown} />
  </div>

  {#if selectedRow}
    <h3>Detail for selected field value</h3>
    <FieldValueDetail data={selectedRow} />
    <FieldValueActions data={selectedRow}
                       on:stalefielddata={handleStaleFieldData} />
  {/if}
{:else if errorMessage}
  <div>{ errorMessage }</div>
{:else}
  <div>No results to display</div>
{/if}